import { defineComponent as _defineComponent } from 'vue'
import { store } from '@/store';
import { PurchaseCtaEnum } from '@/services/product.service';
import ProfessionalVariantViewObject = Vertica.LouisPoulsen.Application.Content.Pages.Product.ProfessionalVariantViewObject;
import PriceInformationB2BAuthenticated from '@/ui/views/product-details/PriceInformationB2BAuthenticated.vue';
import { computed, ref } from 'vue';

interface ProductInfo {
    image: string | null,
    name: string,
    variantNumber: string,
    eanNumber: string | null,
    deliveryTime: string | null,
    code: string,
    allowsCordCutting: boolean
}

export default /*#__PURE__*/_defineComponent({
  __name: 'PriceInformationB2B',
  props: {
    product: null,
    variant: null,
    sparepart: null,
    disabled: { type: Boolean },
    modalMode: { type: Boolean, default: true },
    allowQuote: { type: Boolean, default: false },
    quoteToggle: { type: Boolean, default: false },
    multiColorInfo: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { product?: ProductBaseViewModel<VariantBaseViewObject> | null, variant?: ProfessionalVariantViewObject | null, sparepart?: SparePartVariantBaseViewObject | null, disabled?: boolean, modalMode: boolean, allowQuote: boolean, quoteToggle: boolean, multiColorInfo: boolean }



const isB2BAuthenticated = computed<boolean>(() => store.getters['app/isB2BAuthenticated']);

const showModal = ref<boolean>(false);

const productInfo = computed<ProductInfo>(() => {
    if (props.sparepart) {
        return {
            image: props.sparepart.images.length >= 1 ? props.sparepart.images[0].url : null,
            name: props.sparepart.name,
            variantNumber: props.sparepart.id,
            eanNumber: null,
            deliveryTime: null,
            code: props.sparepart.id,
            allowsCordCutting: false
        };
    }
    return {
        image: props.variant.images.length >= 1 ? props.variant.images[0].url : null,
        name: props.variant.productName,
        variantNumber: props.variant.sapId,
        eanNumber: props.variant.eanNumber,
        deliveryTime: props.variant.deliveryTime || null,
        code: props.variant.variantCode,
        allowsCordCutting: props.variant.allowsCordCutting
    };
});

const buttonLabel = computed<string>(() => {
    if (showAddToBasketB2BButton.value) {
        return 'Pages.ProductDetail.PricingInformationB2B.BuyButton';
    } else {
        return 'Pages.ProductDetail.PricingInformationB2B.ShowPricingButton';
    }
});

const showAddToBasketB2BButton = computed<boolean>(() => {
    let purchaseCta: any;

    if (props.variant) { purchaseCta = props.variant.purchaseCta; } else if (props.sparepart) { purchaseCta = props.sparepart.purchaseCta; }

    return purchaseCta === (PurchaseCtaEnum.AddToBasketB2B as any);
});

const multiColorText = computed<string>(() => {
    if (!props.multiColorInfo) { return; }

    return props.variant.multiColorDetails;
});

const componentType = computed<string>(() => {
    return props.modalMode ? 'modal' : 'div';
});

function closeOverlay() {
    showModal.value = false;
}

function openOverlay() {
    showModal.value = true;
}

function setShowModal(value: boolean): void {
    showModal.value = value;
}

return { __sfc: true,props, isB2BAuthenticated, showModal, productInfo, buttonLabel, showAddToBasketB2BButton, multiColorText, componentType, closeOverlay, openOverlay, setShowModal, PriceInformationB2BAuthenticated }
}

})